export default __webpack_public_path__ + "static/media/BMG_Outdoor.6a0515e4.png";